"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = require("../base");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GridLayerIcon = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(GridLayerIcon, _Component);

  var _super = _createSuper(GridLayerIcon);

  function GridLayerIcon() {
    (0, _classCallCheck2["default"])(this, GridLayerIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GridLayerIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base.Base, this.props, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "11.2",
        y: "11.2",
        className: "cr1",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.8
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "25.4",
        y: "11.2",
        className: "cr2",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.8
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "39.6",
        y: "11.2",
        width: "13.1",
        height: "13.1",
        className: "cr3"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "11.2",
        y: "25.4",
        className: "cr4",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.4
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "25.4",
        y: "25.4",
        className: "cr5",
        width: "13.1",
        height: "13.1"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "39.6",
        y: "25.4",
        className: "cr6",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.8
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "11.2",
        y: "39.6",
        width: "13.1",
        className: "cr1",
        height: "13.1"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "25.4",
        y: "39.6",
        className: "cr2",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.4
        }
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "39.6",
        y: "39.6",
        className: "cr3",
        width: "13.1",
        height: "13.1",
        style: {
          opacity: 0.4
        }
      }));
    }
  }]);
  return GridLayerIcon;
}(_react.Component);

exports["default"] = GridLayerIcon;
(0, _defineProperty2["default"])(GridLayerIcon, "propTypes", {
  /** Set the height of the icon, ex. '16px' */
  height: _propTypes["default"].string,
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
(0, _defineProperty2["default"])(GridLayerIcon, "defaultProps", {
  height: '16px',
  predefinedClassName: 'grid-layer-icon',
  totalColor: 6
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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